import { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from 'react-redux';
import { RootState } from '../redux/store';
import { RouteComponentProps, withRouter } from 'react-router';
import { addJob } from '../utils/api';
import React, { useCallback, useRef } from 'react';
import { useForm } from 'react-hook-form';
import Cron from 'react-js-cron';
import 'antd/dist/antd.css';
import { addedJob, startAddingJob } from '../redux/actions';
import Alert from 'react-bootstrap/Alert';

type Customer = {
  id: string;
  title: string;
};

interface Props {
  error: boolean;
  message: string;
  loading: boolean;
}
interface DispatchProps {
  startAddingJob: () => void;
  addedJob: (
    name: string,
    rssUrl: string,
    customerId: string,
    schedule: string,
    message: string,
    error: boolean,
  ) => {
    type: string;
    payload: { name: string; rssUrl: string; customerId: string; schedule: string; message: string; error: boolean };
  };
}

type ComposedProps = Props & DispatchProps & RouteComponentProps<{ id: string }>;

const JobForm = (props: ComposedProps): JSX.Element => {
  const defaultCronValue = '30 5 * * 1,6';
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const id = props.match.params.id;

  useEffect(() => {
    if (customersListJson !== undefined) {
      customerJson();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const inputRef = useRef(null);
  const [cronValue, setCronValue] = useState(defaultCronValue);
  const customSetValue = useCallback(
    (newValue) => {
      setCronValue(newValue);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [inputRef],
  );

  const [submitting, setSubmitting] = useState(false);
  const [customerIds] = useState(process.env.REACT_APP_CUSTOMER_IDS?.split(', ')!);
  const [customerIdsUrl, setCustomerIdsUrl] = useState<[] | any>([]);
  const customersListJson = process.env.REACT_APP_CUSTOMER_IDS_URL;
  const [showAlert, setShowAlert] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState(false);

  const customerJson = () => {
    fetch(customersListJson as string)
      .then((response) => response.json())
      .then((responseJson) => {
        const customers = (responseJson as Customer[]).map((c) => {
          return {
            key: c.id,
            value: c.title,
          };
        });
        setCustomerIdsUrl(customers as []);
      })
      .catch((err) => console.error(err));
  };

  const onSubmit = async (data) => {
    setSubmitting(true);
    setShowAlert(false);
    props.startAddingJob();

    addJob(data.name, data.rssUrl, data.customerId, cronValue)
      .then((response) => {
        props.addedJob(data.name, data.rssUrl, data.customerId, cronValue, 'Started job add', false);
        setValue('name', null);
        setValue('rssUrl', null);
        setValue('customerId', null);
        setCronValue(defaultCronValue);
        setShowAlert(true);
        setSubmitting(false);
        setError(false);
      })
      .catch((error) => {
        props.addedJob(data.name, data.rssUrl, data.customerId, cronValue, 'Failed to add job', true);
        setShowAlert(true);
        setSubmitting(false);
        console.log(error);
        setError(true);
      });
  };

  const alertVariant = props.error ? 'danger' : 'success';

  const alertMessage = props.error ? 'Failed to add job.' : 'Job added.';

  return (
    <div>
      {showAlert && (
        <Alert variant={alertVariant} dismissible onClose={() => setShowAlert(false)}>
          {alertMessage}
        </Alert>
      )}
      <div className="w-full border mx-auto p-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <h2 className="text-4xl font-medium leading-tight mt-0 text-black-600">Schedule a job</h2>
          </div>
          <div className="flex items-center mb-6">
            <div className="">
              <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">Name:</label>
            </div>
            <div>
              <input
                disabled={submitting}
                className="appearance-none border border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                type="text"
                {...register('name', { required: true })}
              />
              {errors.name?.type === 'required' && <div className="text-red-500 text-left">This field is required</div>}
            </div>
          </div>
          <div className="flex items-center mb-6">
            <div className="">
              <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">Rss Url:</label>
            </div>
            <div style={{ width: '270px' }}>
              <input
                disabled={submitting}
                className={`appearance-none border border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white' focus:${
                  errors.rssUrl?.type === 'required' ? 'border-red-500' : 'border-blue-400'
                }`}
                type="text"
                {...register('rssUrl', {
                  required: true,
                  pattern: {
                    value:
                      // eslint-disable-next-line no-useless-escape
                      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*).[a-z]{2,3}/g,
                    message: 'Invalid url',
                  },
                })}
              />
              {errors.rssUrl?.type === 'required' && <div className="text-red-500 text-left">This field is required</div>}
              {errors.rssUrl && <div className="text-red-500 text-left">{errors.rssUrl.message}</div>}
            </div>
          </div>
          <div className="flex items-center mb-6">
            <div className="">
              <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">Customer:</label>
            </div>
            <div style={{ width: '250px' }}>
              <select
                disabled={submitting}
                className={`appearance-none border border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white' focus:${
                  errors.customerId?.type === 'required' ? 'border-red-500' : 'border-blue-400'
                }`}
                {...register('customerId', { required: true })}
              >
                <option></option>
                {customerIdsUrl !== undefined && customerIdsUrl.length > 0
                  ? customerIdsUrl.map(
                      (c: {
                        value: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
                        key: string;
                      }) => <option value={c.key}>{c.value}</option>,
                    )
                  : customerIds.map((c) => <option>{c}</option>)}
              </select>
              {errors.customerId?.type === 'required' && (
                <div className="text-red-500 text-left">This field is required</div>
              )}
            </div>
          </div>
          <div className="flex items-center mb-6 py-4">
            <div className="">
              <label className="block text-gray-800 font-bold md:text-right pr-4">Schedule:</label>
            </div>
            <div>
              <div className="flex">
                <Cron
                  disabled={submitting}
                  value={cronValue}
                  setValue={customSetValue}
                  //onError={onCronError}
                />
              </div>
              {/*<p className="text-red-500">
                {cronError ? cronError.description : ""}
              </p>*/}
            </div>
          </div>
          <div className="flex items-center">
            <div className="">
              <button
                disabled={submitting}
                type="submit"
                className="add-button shadow bg-green-500 hover:bg-green-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4"
              >
                {id === 'add' ? 'Add Job' : 'Edit Job'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    error: state.jobs.error,
    message: state.jobs.message,
    loading: state.jobs.loading,
  };
};

const dispatchToProps: DispatchProps = {
  startAddingJob,
  addedJob,
};

export default connect(mapStateToProps, dispatchToProps)(withRouter(JobForm));
